.quickSearchToolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 0;
}

.visible {
  visibility: visible;
}

.hidden {
  visibility: hidden;
}

.detailPanelContent {
  padding: 16px;
}

.fullWidth {
  width: 100%;
}
